import React from 'react';

const TermsOfUsagePage: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto py-12 px-4 sm:px-6 lg:px-8 min-h-screen">
      <h1 className="text-4xl font-extrabold text-amber-800 mb-6 border-b pb-2 font-[Cinzel]">
        Terms of Usage (TOS)
      </h1>
      <p className="text-gray-600 mb-4">
        Acceptance Date: 1st January 2024
      </p>
      <div className="space-y-6 text-gray-700">
        <p>
          By using the Sardar Jewellers website, you agree to be bound by these Terms of Usage. Please read them carefully.
        </p>

        <h2 className="text-2xl font-semibold text-amber-700 mt-6">
          Intellectual Property
        </h2>
        <p>
          All content on this site, including images, design, text, and graphics, is the property of Sardar Jewellers and protected by copyright laws.
        </p>

        <h2 className="text-2xl font-semibold text-amber-700 mt-6">
          Use License
        </h2>
        <p>
          Sardar Jewellers grants you permission to view and use this Site and to print individual pages from this Site for your own personal, non-commercial use, provided that you agree to and accept without modification the notices, terms, and conditions set forth herein.
        </p>
        <p>
          You may not modify, copy (except as permitted above), distribute, transmit, display, perform, reproduce, publish, license, create derivative works from, transfer, or sell any information, material, products, or services from this Site.
        </p>
        <p>
          Your use of this Site constitutes your agreement and acceptance without modification of the notices, terms, and conditions set forth herein. In addition, as a condition of your use, you represent and warrant that you will not use this Site for any purpose that is unlawful, immoral, or prohibited by these terms, conditions, and notices. If you do not agree and accept these terms, do not use this Site.
        </p>

        <h2 className="text-2xl font-semibold text-amber-700 mt-6">
          Product Orders
        </h2>
        <ul className="list-disc ml-6 space-y-2">
            <li>While we will use our best efforts to fulfill all orders, Sardar Jewellers cannot guarantee the availability of any particular product displayed on this Site. We reserve the right to discontinue the sale of any product at any time without notice.</li>
            <li>We reserve the right to limit quantities to the amount reasonable for our regular customers.</li>
            <li>Product prices offered on this Site are quoted in Indian Rupees and are valid and effective only within India. Such prices do not include shipping, handling, and other charges, which will be added to your total invoice price.</li>
            <li>While our goal is a 100% error-free Site, we do not guarantee that any content is accurate or complete, including price information and product specifications. If we discover price errors, they will be corrected on our systems, and the corrected price will apply to your order.</li>
            <li>Sardar Jewellers reserves the right to revoke any stated offer and to correct any errors, inaccuracies, or omissions (including after an order has been submitted and accepted).</li>
        </ul>

        <h2 className="text-2xl font-semibold text-amber-700 mt-6">
          No Warranties; Exclusion of Liability
        </h2>
        <p>
          Sardar Jewellers makes no representation about the suitability of the materials on this site for any purpose. All such materials are provided 'As is' without warranty of any kind, express or implied. Sardar Jewellers specifically disclaims all warranties and conditions of any kind, including all implied warranties of merchantability, fitness for a particular purpose, title, and non-infringement.
        </p>
        <p>
          Sardar Jewellers shall not have any liability or responsibility for any errors or omissions in the content of this site, for your action or inaction in connection with this site, or for any damage you may incur. Your use of this site is at your own risk.
        </p>
        <p>
          In no event shall Sardar Jewellers, its affiliates, or agents be liable for any direct, indirect, punitive, incidental, special, or consequential damages arising out of or in any way connected with the use of this site.
        </p>

        <h2 className="text-2xl font-semibold text-amber-700 mt-6">
          Uploaded Content
        </h2>
        <p>
          By submitting any content (including photos) to Sardar Jewellers, you represent and warrant that:
        </p>
        <ul className="list-disc ml-6 space-y-2">
            <li>You are the sole author and owner of the intellectual property rights thereto.</li>
            <li>The content does not violate this agreement and will not cause injury to any person or entity.</li>
            <li>The content is not false, inaccurate, misleading, defamatory, libelous, hateful, or discriminatory.</li>
        </ul>
        <p>
          For any content that you submit, you grant Sardar Jewellers a perpetual, irrevocable, royalty-free, transferable right and license to use, copy, modify, delete, adapt, publish, translate, create derivative works from, and/or distribute such content throughout the world without compensation to you.
        </p>

        <h2 className="text-2xl font-semibold text-amber-700 mt-6">
          General
        </h2>
        <ul className="list-disc ml-6 space-y-2">
            <li>You agree that this agreement and your use of this Site are governed by the laws of India.</li>
            <li>You consent to the exclusive jurisdiction and venue of the courts and tribunals in India in all disputes arising out of or relating to this Site and/or this agreement.</li>
            <li>Sardar Jewellers may at any time and without notice change the terms, conditions, and notices under which this Site is offered; however, any change after your last usage will not be applied retroactively.</li>
            <li>This agreement supersedes all prior communications and constitutes the entire agreement between you and Sardar Jewellers with respect to this site.</li>
        </ul>
      </div>
    </div>
  );
};

export default TermsOfUsagePage;